import { useEffect } from 'react';

import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import Schedule from '../components/Schedule';

function SchedulePage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div>
      <AnnouncementBar />
      <Header hideNavLinks />
      <Schedule />
    </div>
  );
}

export default SchedulePage;
